import PropTypes from 'prop-types';
import { Typography, Box, Tooltip, TextField, Checkbox, FormControlLabel } from '@mui/material';

QuickbooksBookingTypeForm.propTypes = {
  setFormValue: PropTypes.func,
  formValue: PropTypes.object,
};

export default function QuickbooksBookingTypeForm({ formValue, setFormValue }) {

  return <>
    <Tooltip title="The user meant to be used on the Quickbooks login. (this has no effect on the integration and is for infomational purposes)" arrow placement="left">
      <Box>
        <Typography variant="subtitle1">
          User
        </Typography>
        <TextField
          size="small"
          value={formValue.user ?? ""}
          onChange={(e) => setFormValue(value => ({ ...value, user: e.target.value }))}
          fullWidth
        />
      </Box>
    </Tooltip>
    <Tooltip title={<Box>
      <Box>Used for authentication. Added to each request to target a specific Quickbooks instance.</Box>
      <Box>This value can be found on Quickbooks here:</Box>
      <img src="https://res.cloudinary.com/agoraserv/image/upload/v1778156406/Website%20Images/247b03a2-9acc-452d-9b40-527698396ded.png" alt="Quickbooks Cog Popup" />
    </Box>} arrow placement="left">
      <Box>
        <Typography variant="subtitle1">
          Realm Id/Company Id
        </Typography>
        <TextField
          size="small"
          value={formValue.realmId ?? ""}
          onChange={(e) => setFormValue(value => ({ ...value, realmId: e.target.value }))}
          fullWidth
        />
      </Box>
    </Tooltip>   
    <Tooltip title="Sends the customer ids on each invoice line. (not needed if the Quickbooks only has a single entity)" arrow placement="left">
      <FormControlLabel control={<Checkbox checked={formValue.hasEntityId ?? false} onChange={(e) => setFormValue(value => ({ ...value, hasEntityId: e.target.checked }))} />}
        label="Apply customer ids to invoice lines" />
    </Tooltip>
    <Tooltip title="Uses the 'account number' value from Quickbooks as the GL code instead of the underlying id. (if used only GL codes with a 'account number' attached will port over)" arrow placement="left">
      <FormControlLabel control={<Checkbox checked={formValue.useAlternateGLCodesForDisplay ?? false} onChange={(e) => setFormValue(value => ({ ...value, useAlternateGLCodesForDisplay: e.target.checked }))} />}
        label="Use alternate GL Codes for display" />
    </Tooltip>
    <Tooltip title={<Box>
      <Box>Automatically updates GL codes and vendors when we get an update from Quickbooks.</Box>
      <Box>For manual invoices this would add new entries and update existing ones.</Box>
      <Box>For electronic invoices this would only update existing GL codes (only if use alternate GL codes is enabled as otherwise there is nothing to update).</Box>
    </Box>} arrow placement="left">
      <FormControlLabel control={<Checkbox checked={formValue.autoUpdateGLCodesAndVendors ?? false} onChange={(e) => setFormValue(value => ({ ...value, autoUpdateGLCodesAndVendors: e.target.checked }))} />}
        label="Auto update GL Codes and vendors" />
    </Tooltip>
    
  </>;
}
